import { pdfjs } from 'react-pdf';

export async function extractLinksFromPdf(base64: string): Promise<{ url: string; context: string }[]> {
  try {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const pdfDoc = await pdfjs.getDocument({ data: bytes }).promise;
    const extractedLinks: { url: string; context: string }[] = [];
    
    for (let i = 1; i <= pdfDoc.numPages; i++) {
      const page = await pdfDoc.getPage(i);
      const annotations = await page.getAnnotations();
      const textContent = await page.getTextContent();
      
      annotations.forEach((anno: any) => {
        if (anno.subtype === 'Link' && anno.url) {
          let contextText = '';
          if (anno.rect) {
            const [x1, y1, x2, y2] = anno.rect;
            const middleY = (y1 + y2) / 2;
            
            const sameLineItems = textContent.items.filter((item: any) => {
              if (item.transform && item.transform.length >= 6) {
                const itemY = item.transform[5];
                return Math.abs(itemY - middleY) < 15;
              }
              return false;
            });
            sameLineItems.sort((a: any, b: any) => a.transform[4] - b.transform[4]);
            contextText = sameLineItems.map((c: any) => c.str).join('').replace(/\s+/g, ' ').substring(0, 150).trim();
          }
          extractedLinks.push({ url: anno.url, context: contextText });
        }
      });
    }
    return extractedLinks;
  } catch (e) {
    console.error('Error extracting links from PDF', e);
    return [];
  }
}
